<template>
  <div id="q-app">
    <noscript
      ><iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-NX4VWQM"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      ></iframe
    ></noscript>
    <router-view />
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions('auth', ['handleAuthStateChange']),
    ...mapActions('travellyze', ['getSettings'])
  },
  created() {
    this.handleAuthStateChange();
    this.getSettings();
  }
};
</script>
